module.exports = __webpack_public_path__ + "img/download-app.a8b755e5.svg";